import { put } from 'typed-redux-saga';

import { createBroadcastAction } from '../features/broadcast/slice';
import { normalizeCreateBroadcastPayload } from './normalize-create-broadcast-payload';
import { IncomingEvents, IncomingPostMessage } from './types';

type CreateBroadcastPostMessage = Extract<IncomingPostMessage, { event: IncomingEvents.CREATE_BROADCAST }>;

export function* handleCreateBroadcastMessage(message: CreateBroadcastPostMessage) {
    yield* put(createBroadcastAction(normalizeCreateBroadcastPayload(message.payload)));
}
